'use strict';

// Countries and administrative regions that do not require postal codes
module.exports = [
  'AG', // Antigua and Barbuda
  'AI', // Anguilla
  'LC', // Saint Lucia
  'SR', // Suriname
  'SS', // South Sudan
  'SX', // Sint Maarten
  'HK' // Hong Kong
];
